import { FeatureName, useAssetListFilter, useIsFeatureEnabled } from '@gripp/shared-logic';
import { countFilters, FilterHeaders, useOpenedState } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { AddButton } from '../../shared/components/addButton/addButton';
import { ModalButton } from '../../shared/components/modalButton';
import { AssetFilterModal } from './assetFilterModal';
import { AssetSearchModal } from './assetSearchModal';
import { AssetsFiltersOld } from './assetsFilters-old';
import { NewAssetModal } from './newAssetModal';

export const AssetsFilters = () => {
  const isCropCircleEnabled = useIsFeatureEnabled(FeatureName.CropCircleRedesign);
  if (!isCropCircleEnabled) {
    return <AssetsFiltersOld />;
  }
  return <AssetsFiltersBase />;
};

export const AssetsFiltersBase = () => {
  const { data: assetFilter } = useAssetListFilter();
  const filterCount = countFilters(assetFilter);

  const { onOpen: onSearchOpen, onClose: onSearchClose, isOpened: isSearchOpened } = useOpenedState();
  const { onOpen: onFilterOpen, onClose: onFilterClose, isOpened: isFilterOpened } = useOpenedState();

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        onSearchPress={onSearchOpen}
        onFilterPress={onFilterOpen}
        filterCount={filterCount}
        Routes={{}}
      />

      <ModalButton
        label=""
        customButton={(toggleVisibility) => (
          <AddButton onPress={() => toggleVisibility(true)} />
        )}
        modalComponent={({ onComplete }) => (
          <NewAssetModal closeModal={onComplete} />
        )}
        containerStyle={styles.modal}
      />

      <AssetSearchModal isVisible={isSearchOpened} onDismiss={onSearchClose} />
      <AssetFilterModal isVisible={isFilterOpened} onDismiss={onFilterClose} />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
  },
  searchButton: { padding: 8, borderRadius: 8 },
  filterButton: { padding: 8, borderRadius: 8 },
  filterButtonContent: { position: 'relative' },
  badgeContainer: { position: 'absolute', top: -6, right: -6 },
  modal: {
    alignSelf: 'center',
    backgroundColor: 'white',
    padding: 0,
    margin: 0,
    borderRadius: 10,
    width: 560,
    minHeight: 400,
  },
});
